import type { Story } from '@/store/story-types'

export const DEV_PORTFOLIO_STORY: Story = {
  id: 'dev-portfolio-1',
  name: 'Dev Portfolio',
  narrative: 'A developer portfolio showcasing technical skills, project gallery, career timeline, and a contact section to attract freelance clients or recruiters.',
  goals: ['Showcase developer identity', 'Display technical skills', 'Present project gallery', 'Enable contact'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'portfolio-home', description: 'Single-page portfolio with hero, skills grid, projects gallery, timeline, and contact',
      blockRef: { category: 'portfolio', blockId: 'dev-hero' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Showcase',
      description: 'Visitor sees the developer hero introduction',
      steps: [
        { type: 'given', text: 'the visitor opens the portfolio' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the developer hero with name, title, and intro is visible', linkedPageId: 'portfolio-home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Skills',
      description: 'Visitor views the skills grid',
      steps: [
        { type: 'given', text: 'the visitor is on the portfolio' },
        { type: 'when', text: 'they scroll to the skills section' },
        { type: 'then', text: 'a grid of technical skills with icons and proficiency levels is displayed', linkedPageId: 'portfolio-home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Explore Projects',
      description: 'Visitor browses the projects gallery',
      steps: [
        { type: 'given', text: 'the visitor is on the portfolio' },
        { type: 'when', text: 'they scroll to the projects section' },
        { type: 'then', text: 'project cards with screenshots, tech stack, and links are shown', linkedPageId: 'portfolio-home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Contact Developer',
      description: 'Visitor reaches out via the contact section',
      steps: [
        { type: 'given', text: 'the visitor wants to get in touch' },
        { type: 'when', text: 'they scroll to the contact section' },
        { type: 'then', text: 'a contact form with name, email, and message fields is displayed', linkedPageId: 'portfolio-home' },
        { type: 'and', text: 'the form validates and submits the inquiry', linkedFlowId: 'contactDev' },
      ],
    },
  ],
}
